import { useState } from 'react';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';

// import { SkillSetDialog } from './skill-sets.dialog';
import { Button } from '@mui/material';
import { Equipment } from '../../../models/masters/equipment';
import { HistoryDialog } from './history/history.dialog';

interface CustomGridCellProps {
  field: string;
}

interface CellProps {
  equipment: Equipment;
}

const HistoryCell = ({ equipment }: CellProps) => {
  const [isDialogVisible, setIsDialogVisible] = useState(false);

  const dialogHandler = () => {
    setIsDialogVisible(!isDialogVisible);
  };

  return (
    <td>
      <Button className="btnLink" variant="text" onClick={dialogHandler}>
        View History
      </Button>
      {isDialogVisible && (
        <HistoryDialog equipmentID={equipment.equipmentID} isOpen={isDialogVisible} onCloseClick={dialogHandler} />
      )}
    </td>
  );
};

export const CustomGridCell = ({ field }: CustomGridCellProps) => {
  if (field === 'history') {
    return (dataItem: any) => {
      return <HistoryCell equipment={dataItem.dataItem} />;
    };
  }
};
